module.exports = __webpack_public_path__ + "img/1f3ad.46776ba.svg";